(function(){
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const isAr = () => document.documentElement.lang === 'ar';
const T = (o) => isAr() ? o.ar : o.en;
const PRICE = {en:'Price on request', ar:'السعر حسب الطلب'};
const ADD = {en:'Add to request', ar:'أضف إلى الطلب'}, ADDED = {en:'Added', ar:'تمت الإضافة'};
const {CATS, OPT_AR} = window.G7_SHOP_DATA;
const opt = o => isAr() ? (OPT_AR[o] || o) : o;
const cart = [];
const railEl = document.getElementById('rail'), catsEl = document.getElementById('cats');
const esc = s => String(s).replace(/[&<>"]/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]));
let trayIdx = 0;
function render(){
railEl.innerHTML = CATS.map((c, i) => `<a href="#${c.id}" data-id="${c.id}"><i>${String(i + 1).padStart(2, '0')}</i>${esc(T(c))}</a>`).join('');
catsEl.innerHTML = CATS.map(catHTML).join('');
spy();
}
function catHTML(c, i){
{
const head = `<div class="cat-head"><span class="eyebrow">${String(i + 1).padStart(2, '0')} / ${String(CATS.length).padStart(2, '0')}</span><span class="cat-num" aria-hidden="true">${String(i + 1).padStart(2, '0')}</span><h2>${esc(T(c))}</h2><p>${esc(T(c.d))}</p></div>`;
let body;
if (c.trays){
const t = c.items[trayIdx], L = T(t);
body = `<div class="trays"><div class="tray-tabs" role="tablist" aria-label="${esc(T(c))}">` +
c.items.map((t2, k) => `<button type="button" class="tray-tab" role="tab" aria-selected="${k === trayIdx}" data-k="${k}"><img src="${t2.img}" alt=""><span><b>${esc(T(t2)[0])}</b><span>${esc(isAr() ? (['زجاج','جلد','فاخرة','فخار'][k]) : (['Glass','Leather','VIP','Clay'][k]))}</span></span></button>`).join('') +
`</div><div class="tray-stage" role="tabpanel"><img src="${t.img}" alt="${esc(L[0])}"><div class="tray-copy"><h3>${esc(L[0])}</h3><p>${esc(L[1])}</p><ul>${(isAr() ? t.tags.ar : t.tags.en).map(x => `<li>${esc(x)}</li>`).join('')}</ul><div class="row"><span class="price">${esc(T(PRICE))}</span><button type="button" class="add" data-c="${i}" data-k="${trayIdx}">${esc(T(ADD))}</button></div></div></div></div>`;
} else {
body = `<div class="grid">` + c.items.map((p, k) => {
const L = T(p);
return `<article class="card"><div class="ph"><img src="${p.img}" alt="${esc(L[0])}" loading="lazy"></div><div class="bd"><h3>${esc(L[0])}</h3><p>${esc(L[1])}</p>` +
(p.opts ? `<div class="opts" role="group" aria-label="Size">${p.opts.map((o, j) => `<button type="button" aria-pressed="${j === 0}" data-o="${esc(o)}">${esc(opt(o))}</button>`).join('')}</div>` : '') +
`<div class="row"><span class="price">${esc(T(PRICE))}</span><button type="button" class="add" data-c="${i}" data-k="${k}">${esc(T(ADD))}</button></div></div></article>`;
}).join('') + `</div>`;
}
return `<section class="cat" id="${c.id}" aria-label="${esc(T(c))}"><div class="wrap">${head}${body}</div></section>`;
}
}
catsEl.addEventListener('click', e => {
const o = e.target.closest('.opts button');
if (o){ o.parentElement.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', b === o)); return; }
const tt = e.target.closest('.tray-tab');
if (tt){ trayIdx = +tt.dataset.k; const ti = CATS.findIndex(c => c.trays), sec = document.getElementById(CATS[ti].id); if (sec){ sec.outerHTML = catHTML(CATS[ti], ti); spy(); } else render(); document.querySelector(`.tray-tab[data-k="${trayIdx}"]`).focus({preventScroll: true}); return; }
const a = e.target.closest('.add');
if (a){
const c = CATS[+a.dataset.c], p = c.items[+a.dataset.k];
const card = a.closest('.card'); const sel = card && card.querySelector('.opts [aria-pressed="true"]');
const o = sel ? sel.dataset.o : '';
const ex = cart.find(x => x.p === p && x.o === o);
if (ex) ex.q++; else cart.push({p, o, q: 1});
a.classList.add('added'); a.textContent = T(ADDED); setTimeout(() => { a.classList.remove('added'); a.textContent = T(ADD); }, 1300);
updCart(); toast((isAr() ? 'تمت إضافة: ' : 'Added: ') + T(p)[0]);
}
});
/* scroll spy for the category rail.
   Only the rail scrolls sideways; the page itself is never moved (scrollIntoView also
   scrolled the page and fought the visitor's own scrolling). */
function centerChip(a){
const r = railEl.getBoundingClientRect(), b = a.getBoundingClientRect();
const dx = (b.left + b.width / 2) - (r.left + r.width / 2);
if (Math.abs(dx) > 4) railEl.scrollBy({left: dx, behavior: reduce ? 'auto' : 'smooth'});
}
let spyObs = null;
function spy(){
if (spyObs) spyObs.disconnect();
if (!('IntersectionObserver' in window)) return;
spyObs = new IntersectionObserver(es => es.forEach(e => {
if (e.isIntersecting){
railEl.querySelectorAll('a').forEach(a => a.classList.toggle('on', a.dataset.id === e.target.id));
const on = railEl.querySelector('a.on'); if (on) centerChip(on);
}
}), {rootMargin: '-45% 0px -50% 0px'});
document.querySelectorAll('.cat').forEach(s => spyObs.observe(s));
}
/* cart drawer */
const drawer = document.getElementById('drawer'), scrim = document.getElementById('scrim'), drList = document.getElementById('drList'), cartN = document.getElementById('cartN');
function updCart(){
const n = cart.reduce((s, x) => s + x.q, 0);
cartN.hidden = !n; cartN.textContent = n;
drList.innerHTML = cart.length ? cart.map((x, i) => `<div class="dr-item"><img src="${x.p.img}" alt=""><div><b>${esc(T(x.p)[0])}</b><small>${esc(x.o ? opt(x.o) : '')}</small></div><div class="qty"><button type="button" data-i="${i}" data-d="-1" aria-label="Less">−</button><span>${x.q}</span><button type="button" data-i="${i}" data-d="1" aria-label="More">+</button></div></div>`).join('')
: `<p class="dr-empty">${isAr() ? 'لم تُضف أي منتج بعد. ابدأ من المتجر.' : 'Your request is empty. Add something from the shop.'}</p>`;
}
drList.addEventListener('click', e => { const b = e.target.closest('button[data-d]'); if (!b) return; const x = cart[+b.dataset.i]; x.q += +b.dataset.d; if (x.q <= 0) cart.splice(+b.dataset.i, 1); updCart(); });
function openCart(){ drawer.hidden = false; scrim.hidden = false; document.getElementById('drClose').focus(); }
function closeCart(){ drawer.hidden = true; scrim.hidden = true; document.getElementById('cartBtn').focus(); }
document.getElementById('cartBtn').addEventListener('click', openCart);
document.getElementById('drClose').addEventListener('click', closeCart);
scrim.addEventListener('click', closeCart);
document.addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hidden) closeCart(); });
document.getElementById('drForm').addEventListener('submit', async e => {
e.preventDefault();
const err = document.getElementById('drErr'), name = document.getElementById('drName').value.trim(), contact = document.getElementById('drContact').value.trim();
if (!cart.length){ err.textContent = isAr() ? 'أضف منتجاً واحداً على الأقل.' : 'Add at least one product.'; return; }
if (!name){ err.textContent = isAr() ? 'اكتب اسمك من فضلك.' : 'Please enter your name.'; document.getElementById('drName').focus(); return; }
if (!(/@/.test(contact) || contact.replace(/\D/g, '').length >= 7)){ err.textContent = isAr() ? 'اكتب رقم هاتف أو بريداً إلكترونياً صحيحاً.' : 'Enter a valid phone number or email.'; document.getElementById('drContact').focus(); return; }
err.textContent = '';
const text = cart.map(x => `${x.q} × ${T(x.p)[0]}${x.o ? ' (' + opt(x.o) + ')' : ''}`).join('\n');
const btn = document.getElementById('drSend'); btn.disabled = true;
let ok = false;
if (window.Shopify){
try {
const fd = new FormData(); fd.append('form_type', 'contact'); fd.append('utf8', '✓'); fd.append('contact[name]', name);
if (/@/.test(contact)) fd.append('contact[email]', contact); else { fd.append('contact[email]', 'no-email@ghaf7.ae'); fd.append('contact[phone]', contact); }
fd.append('contact[Service]', 'shop-quote-request'); fd.append('contact[body]', '[Ghaf7 shop quote request]\n' + text);
const r = await fetch('/contact#contact_form', {method: 'POST', body: fd, credentials: 'same-origin'});
ok = r.ok && !/challenge/.test(r.url);
} catch(x){ ok = false; }
}
btn.disabled = false;
if (ok){
cart.length = 0; updCart();
drList.innerHTML = `<div class="dr-done"><b>${isAr() ? 'وصلنا طلبك' : 'Quote request received'}</b><p>${isAr() ? 'سيتواصل معك فريقنا خلال يوم عمل لتأكيد الأسعار وموعد التوصيل.' : 'Our team will contact you within one working day to confirm prices and delivery.'}</p></div>`;
} else {
try { await navigator.clipboard.writeText(name + '\n' + contact + '\n\n' + text); } catch(x){}
err.textContent = isAr() ? 'تعذّر الإرسال من هنا. نسخنا طلبك، أرسله إلى info@ghaf7.ae وسنرد عليك خلال يوم عمل.' : 'We could not send it from here. Your order is copied: email it to info@ghaf7.ae and we will reply within one working day.';
}
});
const toastEl = document.getElementById('toast'); let tt;
function toast(m){ toastEl.textContent = m; toastEl.classList.add('show'); clearTimeout(tt); tt = setTimeout(() => toastEl.classList.remove('show'), 1900); }
/* language */
const staticNodes = Array.from(document.querySelectorAll('[data-ar]')).map(el => ({el, en: el.innerHTML.trim(), ar: el.dataset.ar}));
const langBtn = document.getElementById('langBtn');
function setLang(l){
document.documentElement.lang = l; document.documentElement.dir = l === 'ar' ? 'rtl' : 'ltr';
staticNodes.forEach(n => n.el.innerHTML = l === 'ar' ? n.ar : n.en);
langBtn.textContent = l === 'ar' ? 'English' : 'العربية'; langBtn.lang = l === 'ar' ? 'en' : 'ar';

render(); updCart();
try { localStorage.setItem('ghaf7-lang', l); } catch(e){}
}

const startAr = document.documentElement.lang === 'ar';
if (startAr) setLang('ar'); else { render(); updCart(); }
const hdr = document.querySelector('.top'), rail = document.querySelector('.rail');
const setHH = () => { const h = getComputedStyle(hdr).position === 'sticky' ? hdr.offsetHeight : 0; document.documentElement.style.setProperty('--hh', h + 'px'); document.documentElement.style.scrollPaddingTop = (h + (rail ? rail.offsetHeight : 0) + 16) + 'px'; };
setHH(); if ('ResizeObserver' in window) new ResizeObserver(setHH).observe(hdr); else window.addEventListener('resize', setHH);
if (location.hash){ const t = document.querySelector(location.hash); if (t) setTimeout(() => t.scrollIntoView(), 50); }
})();